import { render } from "./PdfGeneralData.vue?vue&type=template&id=70d899ee&scoped=true&ts=true"
import script from "./PdfGeneralData.vue?vue&type=script&lang=ts"
export * from "./PdfGeneralData.vue?vue&type=script&lang=ts"

import "./PdfGeneralData.vue?vue&type=style&index=0&id=70d899ee&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d899ee"]])

export default __exports__